<template>
  <AppDrop @drop="moveTaskOrColumn">
    <AppDrag
      class="task"
      :transferData="{
        type: 'task',
        fromColumnIndex: columnIndex,
        fromTaskIndex: taskIndex,
      }"
      @click.native="goToTask(task.id)"
    >
      {{ task.id }}
      <span class="w-full flex-no-shrink font-bold">
        {{ task.name }}
      </span>
      <p v-if="task.description" class="w-full flex-no-shirnk mt-1 text-sm">
        {{ task.description }}
      </p>
    </AppDrag>
  </AppDrop>
</template>

<script>
import moveTaskAndColumns from '@/mixins/moveTaskAndColumns.js'
import AppDrag from './AppDrag.vue'
import AppDrop from './AppDrop.vue'

export default {
  components: {
    AppDrag,
    AppDrop,
  },
  mixins: [moveTaskAndColumns],
  props: {
    task: {
      type: Object,
      required: true,
    },
    taskIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    goToTask(task) {
      this.$router.push({ name: 'task', params: { id: task } })
      // this.$router.push({ path: 'task/' + task })
    },
  },
}
</script>

<style lang="postcss">
.task {
  @apply flex items-center flex-wrap shadow mb-2 py-2 px-2 rounded bg-white no-underline;
}
</style>
